import React, { useState } from "react";
import PropTypes from "prop-types";
import h from "h";
import { xhrPost, xhrPut } from "common/xhr";
import CreateAccountWizard from "./CreateAccountWizard";
import "checkout/styles/tos.scss";
import "checkout/styles/gen-form.scss";

const SignupPage = (props) => {
  const {
    version,
    verificationRequired,
  } = props;
  // https://jira.tucows.net/browse/HOV-451
  // No need to do any modal or anything...this check box handles the consent/permission from the user.
  const optInPayload = {
    email_notifications: {
      newsletters: true,
      consent: true,
      tag: "tos",
    },
  };

  const [header, setHeader] = useState("Create Account");
  const [step, setStep] = useState("account_form");

  async function createAccount(params) {
    try {
      await xhrPost("/signup", { account: { terms_version: version, ...params } });
      if (params.tosValues.newsletter) {
        await xhrPut("/api/settings", optInPayload);
      }
      window.location.replace("/control_panel");
    } catch (error) {
      return Promise.reject(error.errors);
    }
  }
  const actions = { createAccount };
  const isAccountForm = step === "account_form";
  return h(".signup", [
    h(".header", [h("h1", header)]),
    h(CreateAccountWizard, {
      actions,
      verificationRequired,
      setHeader,
      setStep
    }),
    isAccountForm && h(
      ".footer",
      h("p", [
        h("span", "Already have an account? "),
        h("a", { href: "/signin" }, "Sign in."),
      ])
    ),
  ]);
};

SignupPage.propTypes = {
  version: PropTypes.number.isRequired,
  verificationRequired: PropTypes.bool.isRequired,
};

export default SignupPage;
